import * as React from 'react';
import equal from 'fast-deep-equal/react';
import styles from './RandomBundle.scss';
import classNames from 'classnames';
import { isMobileOrTabletWindow } from '~/utils/utils';
import { State } from '~/Reducers';
import { useSelector } from 'react-redux';
import { FadeInDiv } from '~/components/Transitions';

interface IRandomBundleDoors {
    isEnabled: boolean;
    isEnabledFreeOpen: boolean;
    bundle: IBundle;
    activeBundle: IBundle;
    periodicBundleNextDate: number;
    isAlreadyPurchased?: boolean;
}

interface IRandomBundleDoorsState {
    accountId: number;
}

const stateSelector = (state: State): IRandomBundleDoorsState => {
    return {
        accountId: state.ReducerAccount.id,
    };
};

const RandomBundleImage = (props: IRandomBundleDoors) => {
    const state = useSelector<State, IRandomBundleDoorsState>(stateSelector, equal);
    const itemElement: React.RefObject<HTMLDivElement> = React.useRef();

    const isParentBundle = props.activeBundle?.id === props.bundle.id;
    let itemBackgroundImage = isParentBundle ? props.activeBundle?.icons.medium || props.activeBundle?.icons.big : props.activeBundle?.icons?.medium || props.bundle.icons?.medium;

    if (!state.accountId || props.isAlreadyPurchased || props.isEnabledFreeOpen) {
        if (isMobileOrTabletWindow) {
            itemBackgroundImage = props.bundle.icons?.big;
        }

        return <div className={styles.defaultImageWrapper} style={{ backgroundImage: `url(${itemBackgroundImage})` }} />;
    }

    if (props.isEnabled) {
        const classesImageWrapper = classNames(styles.imageWrapper, {
            [styles.open]: state.accountId && !props.isEnabledFreeOpen,
            [styles.mobileImage]: isMobileOrTabletWindow,
            ...(props.bundle.decoration || []),
        });

        if (isMobileOrTabletWindow) {
            itemBackgroundImage = props.activeBundle?.icons.small || props.bundle.icons?.small;
        }

        return (
            <React.Fragment>
                {!props.isEnabledFreeOpen && (
                    <FadeInDiv
                        className={classesImageWrapper}
                        style={{
                            backgroundImage: `url(${itemBackgroundImage})`,
                        }}
                    />
                )}
            </React.Fragment>
        );
    }

    if (!props.periodicBundleNextDate) {
        return (
            <FadeInDiv
                className={styles.imageWrapper}
                ref={itemElement}
                style={{
                    backgroundImage: `url(${itemBackgroundImage})`,
                }}
            />
        );
    }

    return null;
};

export default React.memo(RandomBundleImage);
